import { Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { ITranslation } from '../../../../types/interfaces/translation';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import { ILanguage } from '../../../../types/interfaces/language';

export function getCellReducers(
  t: TFunction,
  classes: any,
  languages: ILanguage[],
  { canDelete, canEdit },
  onEdit: (translation: ITranslation) => void,
  onDelete: (translation: ITranslation) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.KEY,
      cellReducer: (translation: ITranslation) => {
        return <div className={classes.key}>{translation.key}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.LANGUAGE,
      cellReducer: (translation: ITranslation) => {
        const language = languages?.find(
          (language) => language.id === translation.languageId,
        );
        return (
          <div className={classes.language}>
            {language?.name || language?.key}
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.VALUE,
      cellReducer: (translation: ITranslation) => {
        return <div className={classes.value}>{translation.value}</div>;
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (translation: ITranslation) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(translation);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(translation);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
